//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { GetSearchResponse } from './models/GetSearchResponse';
import type { SearchAllSgmRequest } from './models/SearchAllSgmRequest';
import { SearchResultType } from './models/SearchResultType';
import type { SgmServiceLitePaginatedResponse } from './models/SgmServiceLitePaginatedResponse';
import { Utilities } from './Utilities';

export class SearchsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        search: (
			searchTerm?: string,
			language?: string,
			page?: number,
			pageSizeBySearchType?: number,
			filters_sgm_categoryKeys?: string,
			filters_sgm_subcategoryKeys?: string,
			itemTypes?: SearchResultType[],
        ): string => {
            let clientRequestUrl = '/api/v1/searchs?';
            if (searchTerm === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('searchTerm'));
            } else if (searchTerm !== undefined) {
                clientRequestUrl += `searchTerm=${encodeURIComponent(String(searchTerm))}&`;
            }
            if (language === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('language'));
            } else if (language !== undefined) {
                clientRequestUrl += `language=${encodeURIComponent(String(language))}&`;
            }
            if (page === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('page'));
            } else if (page !== undefined) {
                clientRequestUrl += `page=${encodeURIComponent(String(page))}&`;
            }
            if (pageSizeBySearchType === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('pageSizeBySearchType'));
            } else if (pageSizeBySearchType !== undefined) {
                clientRequestUrl += `pageSizeBySearchType=${encodeURIComponent(String(pageSizeBySearchType))}&`;
            }
            if (filters_sgm_categoryKeys === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('filters_sgm_categoryKeys'));
            } else if (filters_sgm_categoryKeys !== undefined) {
                clientRequestUrl += `filters.sgm.categoryKeys=${encodeURIComponent(String(filters_sgm_categoryKeys))}&`;
            }
            if (filters_sgm_subcategoryKeys === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('filters_sgm_subcategoryKeys'));
            } else if (filters_sgm_subcategoryKeys !== undefined) {
                clientRequestUrl += `filters.sgm.subcategoryKeys=${encodeURIComponent(String(filters_sgm_subcategoryKeys))}&`;
            }
            if (itemTypes === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('itemTypes'));
            } else if (itemTypes !== undefined) {
                if (itemTypes) {
                    itemTypes.forEach(item => { clientRequestUrl += `itemTypes=${encodeURIComponent(String(item))}&`; });
                }
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        searchAllSgm: (): string => {
            let clientRequestUrl = '/api/v1/searchs/do-search-all-sgm';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Search multi source on sgm services, sg other services, peoples, companies according to criteria
     * @param searchTerm (optional) Term used to search for services.
     * @param language (optional) Lang of Content. Default: en
     * @param page (optional) Number of the current page (default: 1)
     * @param pageSizeBySearchType (optional) Number of elements on page (default: 20, maximum: 500)
     * @param filters_sgm_categoryKeys (optional) Filter by category key separated by comma
     * @param filters_sgm_subcategoryKeys (optional) Filter by subcategory key separated by comma
     * @param itemTypes (optional) Return only specific item types. Return all if not specified
     * @return Search multi source result
     */
    async search(
        searchTerm?: string,
        language?: string,
        page?: number,
        pageSizeBySearchType?: number,
        filters_sgm_categoryKeys?: string,
        filters_sgm_subcategoryKeys?: string,
        itemTypes?: SearchResultType[],
    ): Promise<GetSearchResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.search(
            searchTerm,
            language,
            page,
            pageSizeBySearchType,
            filters_sgm_categoryKeys,
            filters_sgm_subcategoryKeys,
            itemTypes,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetSearchResponse>(_response, false, []);
    }

    /**
     * Search sgm services according to criteria. WITHOUT USER CONTEXT
     * @param body (optional) 
     * @return Search multi source result
     */
    async searchAllSgm(
        body?: SearchAllSgmRequest,
    ): Promise<SgmServiceLitePaginatedResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.searchAllSgm();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SgmServiceLitePaginatedResponse>(_response, false, []);
    }
}
